import React from "react";
import Layout from "../layout/Layout";
import Banner from "../components/list/Banner";
import IndustryLeaders from "../components/industry-leaders/industry-leaders";
import FeatureGrid from "../components/list/FeatureGrid";
import Cta from "../components/list/Cta";
import Testimonials from "../components/list/Testimonials";

const ListBuilding = () => {
  return (
    <Layout>
      <Banner />
      <IndustryLeaders />
      <FeatureGrid />
      <Cta />
      <Testimonials />
    </Layout>
  );
};

export default ListBuilding;
